<!--
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:26
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-29 18:52:38
 * @Description: 这是重要的滑竿组件， main control was from noUISlider
-->

<template>
    <div class="slider2 relative" @touchstart="onTouchStart" name="slider.vue" :style="{ '--the-width': '100px' }" v-observe-width>
        <slot name="noUISlider"></slot>
        <!-- Left Roll -->
        <div class="slider2-roll" name="●left" :style="resultPosition1">
            <div class="slider2-roll-ins flx left-roll"></div>
        </div>

        <!-- Middle Roll -->
        <div class="slider2-roll mid-roll" :style="resultPosition2">
            <div class="slider2-roll-ins flx midle-sld">
                <svg fill="none" width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
                    <circle :fill="isIn ? '#24e34d' : '#fa305c'" cx="13.7109" cy="13.8593" r="13.5"></circle>
                    <circle fill="white" cx="13.7109" cy="13.8593" r="11"></circle>
                    <path stroke="#CFCFCF" d="M13.7148 10.5096L13.7148 17.2089" stroke-width="1.72016"
                        stroke-linecap="round"></path>
                    <path stroke="#CFCFCF" d="M9.24609 12.185L9.24609 15.5347" stroke-width="1.72016"
                        stroke-linecap="round"></path>
                    <path stroke="#CFCFCF" d="M18.1758 12.185L18.1758 15.5347" stroke-width="1.72016"
                        stroke-linecap="round"></path>
                </svg>
            </div>
        </div>

        <!-- Right roll -->
        <div class="slider2-roll" name="●right" :style="resultPosition3">
            <div class="slider2-roll-ins flx right-roll"></div>
        </div>

        <div class="slider2-result" style="height: 22px; transform: translateX(calc(27.3055%)) translateY(30.354%)"
            :style="resultPosition">
            <!-- ↓这是骰子容器  -->
            <div class="slider2-result-ins relative" :class="!isSubmiting && isAnimate && 'animWin'"
                :style="{ '--duration': spaceDiceConfig.notFastTime + 'ms' }">
                <img class="z-[2] absolute left-0 pointer-events-none" :src="DicePointerImg" />
                <svg class="z-[0] absolute right-[-1.8px] bottom-[-1px]"
                    :class="isGreen ? 'text-[#24e34d]' : 'text-[#F82E59FF]'" width="44" height="50" viewBox="0 0 44 50"
                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13.1322 38.5246H31.1322L22.803 49.2575C22.5266 49.6136 21.7378 49.6136 21.4614 49.2575L13.1322 38.5246Z">
                    </path>
                    <path
                        d="M5.93955 8.49031L17.7424 4.14187C20.5799 3.09649 23.693 3.07297 26.5459 4.07535L37.8961 8.06324C39.5282 8.6367 40.6068 10.1944 40.5692 11.924L40.251 26.5595C40.177 29.9651 38.3745 33.0988 35.4679 34.875L26.3632 40.439C23.7713 42.0229 20.5059 42.0023 17.9342 40.3858L8.94918 34.7381C6.2373 33.0335 4.50611 30.1329 4.29304 26.9369L3.33123 12.5098C3.21323 10.7398 4.27503 9.10355 5.93955 8.49031Z">
                    </path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M25.7172 6.434C23.4129 5.62439 20.8985 5.64339 18.6067 6.48773L6.80381 10.8362C6.17962 11.0661 5.78144 11.6797 5.82569 12.3435L6.78751 26.7706C6.94731 29.1676 8.2457 31.3431 10.2796 32.6215L19.2646 38.2692C21.0327 39.3806 23.2776 39.3948 25.0596 38.3058L34.1643 32.7418C36.3442 31.4096 37.6961 29.0594 37.7516 26.5052L38.0698 11.8697C38.0839 11.2211 37.6794 10.6369 37.0674 10.4219L25.7172 6.434ZM16.8782 1.79601C20.2613 0.549603 23.9731 0.521558 27.3747 1.7167L38.7248 5.70459C41.3771 6.63647 43.1297 9.16779 43.0686 11.9783L42.7504 26.6139C42.6579 30.8708 40.4048 34.7879 36.7715 37.0082L27.6668 42.5722C24.2649 44.6511 19.9792 44.6241 16.6038 42.5024L7.61875 36.8547C4.2289 34.7239 2.06491 31.0983 1.79858 27.1032L0.836768 12.6761C0.645023 9.79988 2.37045 7.14097 5.07528 6.14445L16.8782 1.79601Z">
                    </path>
                </svg>
            </div>
        </div>
        <div class="slider2-result" style="
                height: 22px;
                z-index: -1;
                transform: translateX(calc(27.3055%)) translateY(30.354%);
            " :style="resultPosition"></div>

        <div class="forline-cont">
            <div class="result-line" style="transform: translateX(calc(27.3055%)) translateY(30.354%)"
                :style="resultPosition">
                <p></p>
            </div>
        </div>

        <!-- middle Slider -->
        <div :class="isIn ? 'in' : 'out'" class="noUi-target c-range-slider noUi-ltr noUi-horizontal noUi-txt-dir-ltr"
            :ref="(el) => containerRef = el">
            <div class="noUi-base">
                <div class="noUi-connects">
                    <div class="noUi-connect noUi-draggable" :style="{
                        transform: `translate(${dragableX}%, 0px) scale(${dragableScale}, 1)`,
                    }"></div>
                </div>
            </div>
        </div>
        <div class="underslide">
            <p class="under_num1">0</p>
            <p class="under_num2">2 500</p>
            <p class="under_num3">5 000</p>
            <p class="under_num4">7 500</p>
            <p class="under_num5">9 999</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { spaceDiceConfig } from '../js/composable';
import DicePointerImg from '@/assets/imgs/casino/spacedicePointer.png';
import useGlobalStore from '@/stores/global';

const props = defineProps({
    isIn: {
        type: Boolean,
        required: true,
    },
    labelRange: {
        type: Object as PropType<{ min: number; max: number }>,
        required: true,
    },
    lastArrow: {
        type: Number,
        default: 0, // 0-1 表示左侧或右侧刚刚移动了 
    },
    luckyNumber: {
        type: Number,
        required: true,
    },
    betAmount: {
        type: Number,
        required: true,
    },
    isSubmiting: {
        type: Boolean,
        default: true,
    },
    isAnimate: {
        type: Boolean,
        default: false,
    },
});

const globalStore = useGlobalStore();
const containerRef = ref(); // 保存 dom 对象
const emit = defineEmits(['update:isIn', 'update:labelRange']);

const dragableX = computed(() => {
    const clientWidth = containerRef.value?.clientWidth;
    const range = spaceDiceConfig.max - spaceDiceConfig.min;

    if (clientWidth) {
        return (props.labelRange.min / range) * 100;
    }
    return 0;
});

const dragableScale = computed(() => {
    if (props.labelRange) {
        const range = spaceDiceConfig.max - spaceDiceConfig.min;
        return (props.labelRange.max - props.labelRange.min) / range;
    }
    return 0;
});

const midle = computed(() => {
    if (props.labelRange) {
        return (props.labelRange.max + props.labelRange.min) / 2;
    }
    return 0;
});

// 注意下方的多个特殊变量： the2ndValue 
// 这个变量顶替了之前用的旧值， 旧值注释在其右侧 

const resultPosition = computed(() => {
    if (!import.meta.client) return '';
    const containerWidth = containerRef.value?.clientWidth;
    const the2ndValue = globalStore.innerWidth; // containerWidth;
    return getPos(props.luckyNumber, the2ndValue);
});

// ↓ 为"左侧"圆球计算样式 
const resultPosition1 = computed(() => {
    if (!import.meta.client) return '';
    const the2ndValue = globalStore.innerWidth; // midle.value;
    let transform = getPos(props.labelRange.min, the2ndValue);
    if (props.lastArrow === 0) {
        transform += '; z-index: 3;';
    }
    return transform;
});

// ↓ 为"中间的"圆球计算样式 
const resultPosition2 = computed(() => {
    if (!import.meta.client) return '';
    const containerWidth = containerRef.value?.clientWidth;
    const the2ndValue = globalStore.innerWidth; // containerWidth;
    const sResult = getPos(midle.value, the2ndValue);
    return sResult;
});

// ↓ 为"右侧"圆球计算样式 
const resultPosition3 = computed(() => {
    if (!import.meta.client) return '';
    const the2ndValue = globalStore.innerWidth; // midle.value;
    let transform = getPos(props.labelRange.max, the2ndValue);
    if (props.lastArrow === 1) {
        transform += '; z-index: 3;';
    }
    return transform;
});

const isGreen = computed(() => {
    if (props.isIn) {
        const isBetAmountInRange =
            props.luckyNumber >= props.labelRange.min && props.luckyNumber <= props.labelRange.max;
        return isBetAmountInRange;
    } else {
        const isBetAmoutOutRange =
            props.luckyNumber < props.labelRange.min || props.luckyNumber > props.labelRange.max;
        return isBetAmoutOutRange;
    }
});

// ↓ 重要方法，计算样式
function getPos(
    tt: number,
    ss: number,
) {
    const scaleFactor = 0.0100010001;
    const ee = scaleFactor * tt;
    const distanceFrom50 = Math.abs(50 - ee);
    const offset = ee * 0.02;
    let nn = ss / 20_000; // Divide by 20000 instead of 2e4 for clarity
    const maxN = 0.03405;
    nn = Math.min(nn, maxN); // Ensure n doesn't exceed maxN

    const translateYOffset = ss > 600 ? 15 : 17;
    const translateYValue = distanceFrom50 * distanceFrom50 * nn + translateYOffset;

    // Using template literals for better readability
    const transformValue = `
        transform: translateX(calc(${ee - offset}%)) translateY(${translateYValue}%) !important;
    `.trim();
    return transformValue;
}

const vObserveWidth = {
    mounted(el) {
        let timer01 = null;
        el._resizeObserver = new ResizeObserver((entries) => {
            clearTimeout(timer01);
            timer01 = setTimeout(()=>{
                for (const entry of entries) {
                    const width = entry.target?.['offsetWidth']; // 获取最新高度（包含边框和滚动条）
                    entry.target?.['style'].setProperty('--the-width', `${width}px`);
                    // console.log('Height  updated:', height)
                }
            }, 100);
        });
        el._resizeObserver.observe(el); // 开始观察
    },
    beforeUnmount(el) {
        // 组件卸载时销毁观察器 
        if (el._resizeObserver) {
            el._resizeObserver.disconnect();
            delete el._resizeObserver;
        };
    },
};

function onTouchStart(event: TouchEvent) {
    if (event.cancelable) {
        event.preventDefault();
    }
    event.stopPropagation();
}

</script>

<style lang="scss" scoped>
.result-line {
    height: 100%;
    position: absolute;
    transition: transform 0.3s ease;
    width: 100%;
}

.result-line p {
    background: #fff9;
    height: 100%;
    transform: translate(4px, -15px);
    width: 2px;
}

.forline-cont {
    height: 100%;
    left: 0;
    -webkit-mask-image: url(../img/myMaskCut.DvbYMU0n.svg);
    mask-image: url(../img/myMaskCut.DvbYMU0n.svg);
    mask-mode: alpha;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
}

@media (max-width: 600px) {
    .forline-cont {
        -webkit-mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
        mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
    }
}

@media (max-width: 832px) {
    .opened-left-panel .forline-cont {
        -webkit-mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
        mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
    }
}

@media (max-width: 925px) {
    .opened-right-panel .forline-cont {
        -webkit-mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
        mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
    }
}

@media (max-width: 940px) {
    .opened-contests-panel .forline-cont {
        -webkit-mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
        mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
    }
}

@media (max-width: 1157px) {
    .opened-left-panel.opened-right-panel .forline-cont {
        -webkit-mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
        mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
    }
}

@media (max-width: 1172px) {
    .opened-left-panel.opened-contests-panel .forline-cont {
        -webkit-mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
        mask-image: url(../img/myMaskMobCut.D_nKvdzg.svg);
    }
}

.flx {
    align-items: center;
    display: flex;
    justify-content: center;
}

.slider2 {
    height: calc(var(--the-width) * 0.057);
    margin: 35px auto 50px;
    max-width: 581px;
    position: relative;
    width: 95%;
    z-index: 3;
    overscroll-behavior-x: contain;
    /* Allow only vertical scrolling (so horizontal drags aren't hijacked by the browser) */
    touch-action: pan-y;
}

@media (max-width: 600px) {
    .slider2 {
        height: calc(var(--the-width) * 0.07);
        margin: 60px auto 45px; // 旧值： 63px auto 55px; 
        max-width: 441px;
    }
}

@media (max-width: 832px) {
    .opened-left-panel .slider2 {
        height: calc(var(--the-width) * 0.07);
        margin: 63px auto 55px;
        max-width: 441px;
    }
}

@media (max-width: 925px) {
    .opened-right-panel .slider2 {
        height: calc(var(--the-width) * 0.07);
        margin: 63px auto 55px;
        max-width: 441px;
    }
}

@media (max-width: 940px) {
    .opened-contests-panel .slider2 {
        height: calc(var(--the-width) * 0.07);
        margin: 63px auto 55px;
        max-width: 441px;
    }
}

@media (max-width: 1157px) {
    .opened-left-panel.opened-right-panel .slider2 {
        height: calc(var(--the-width) * 0.07);
        margin: 63px auto 55px;
        max-width: 441px;
    }
}

@media (max-width: 1172px) {
    .opened-left-panel.opened-contests-panel .slider2 {
        height: calc(var(--the-width) * 0.07);
        margin: 63px auto 55px;
        max-width: 441px;
    }
}

.slider2-roll {
    height: 22px;
    left: 0;
    opacity: 1;
    pointer-events: none;
    position: absolute;
    top: -7px;
    width: 100%;
    z-index: 2;
}

.slider2-roll-ins {
    background: #fff;
    border-radius: 50%;
    height: 22px;
    pointer-events: none;
    transform: translate(-4px);
    width: 22px;
}

.slider2-roll:hover {
    opacity: 0.6;
}

.slider2-result,
.slider2-roll:active {
    pointer-events: none;
}

.slider2-result {
    left: 0;
    position: absolute;
    top: -7px;
    transition: transform 0.3s ease;
    width: 100%;
    z-index: 2;
}

.slider2-result-ins {
    position: relative;
    transform: translate(-39%) translateY(-48px);
    width: -moz-max-content;
    width: max-content;
    width: 44px;
    height: 50px;
}

.slider2-result-ins img {
    left: 0;
    position: absolute;
    top: 0;
    transform: translate(1px, 3px) scale(1.07);
}

.slider2 .noUi-horizontal .noUi-handle {
    box-shadow: none;
    height: 33px;
    left: -15px;
    opacity: 0;
    top: 0;
    width: 21.8px;
}

.slider2 .in {
    background: #fa305c;
}

.slider2 .in .noUi-connect,
.slider2 .out {
    background: #24e34d;
}

.slider2 .out .noUi-connect {
    background: #fa305c;
}

.slider2 .noUi-target {
    height: 120%;
    -webkit-mask-image: url(../img/myMask.uC3nVrfh.svg);
    mask-image: url(../img/myMask.uC3nVrfh.svg);
    mask-mode: alpha;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
}

@media (max-width: 600px) {
    .slider2 .noUi-target {
        -webkit-mask-image: url(../img/myMaskMob.OGsadbzO.svg);
        mask-image: url(../img/myMaskMob.OGsadbzO.svg);
    }
}

@media (max-width: 832px) {
    .opened-left-panel .slider2 .noUi-target {
        -webkit-mask-image: url(../img/myMaskMob.OGsadbzO.svg);
        mask-image: url(../img/myMaskMob.OGsadbzO.svg);
    }
}

@media (max-width: 925px) {
    .opened-right-panel .slider2 .noUi-target {
        -webkit-mask-image: url(../img/myMaskMob.OGsadbzO.svg);
        mask-image: url(../img/myMaskMob.OGsadbzO.svg);
    }
}

@media (max-width: 940px) {
    .opened-contests-panel .slider2 .noUi-target {
        -webkit-mask-image: url(../img/myMaskMob.OGsadbzO.svg);
        mask-image: url(../img/myMaskMob.OGsadbzO.svg);
    }
}

@media (max-width: 1157px) {
    .opened-left-panel.opened-right-panel .slider2 .noUi-target {
        -webkit-mask-image: url(../img/myMaskMob.OGsadbzO.svg);
        mask-image: url(../img/myMaskMob.OGsadbzO.svg);
    }
}

@media (max-width: 1172px) {
    .opened-left-panel.opened-contests-panel .slider2 .noUi-target {
        -webkit-mask-image: url(../img/myMaskMob.OGsadbzO.svg);
        mask-image: url(../img/myMaskMob.OGsadbzO.svg);
    }
}

.slider2 .noUi-tooltip {
    background: #263041;
    border-radius: 8px;
    bottom: 0;
    color: #93acd3;
    display: block;
    font-size: 12px;
    font-weight: 600;
    height: 36px;
    left: 0;
    letter-spacing: -0.02em;
    line-height: 16px;
    padding: 10px 12px;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    white-space: nowrap;
    width: 57px;
}

.slider2 .noUi-tooltip:after {
    background: #263041;
    bottom: -10px;
    content: '';
    display: block;
    height: 12px;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%) rotate(45deg);
    width: 12px;
}

.slider2 .noUi-horizontal .noUi-tooltip {
    display: none;
}

.noUi-vertical .noUi-tooltip {
    right: 120%;
    top: 50%;
    transform: translateY(-50%);
}

.noUi-target,
.noUi-target * {
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    touch-action: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}

.noUi-target {
    direction: ltr;
    position: relative;
}

.noUi-base,
.noUi-connects {
    height: 100%;
    position: relative;
    width: 100%;
    z-index: 1;
}

.noUi-connects {
    overflow: hidden;
    z-index: 0;
}

.noUi-connect,
.noUi-origin {
    left: 0;
    position: absolute;
    top: 0;
    -ms-transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform-style: preserve-3d;
    transform-style: flat;
    will-change: transform;
    z-index: 1;
}

.noUi-connect {
    height: 100%;
    width: 100%;
}

.noUi-origin {
    height: 10%;
    width: 10%;
}

html:not([dir='rtl']) .noUi-horizontal .noUi-origin {
    left: auto;
    right: 0;
}

.noUi-vertical .noUi-origin {
    width: 0;
}

.noUi-horizontal .noUi-origin {
    height: 0;
}

.noUi-handle {
    backface-visibility: hidden;
    position: absolute;
}

.noUi-touch-area {
    height: 100%;
    width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
    transition: transform 0.3s;
}

.noUi-state-drag * {
    cursor: inherit !important;
}

[disabled].noUi-horizontal {
    opacity: 0.85;
}

.noUi-vertical {
    width: 18px;
}

.noUi-vertical .noUi-handle {
    height: 34px;
    left: -6px;
    top: -17px;
    width: 28px;
}

html:not([dir='rtl']) .noUi-horizontal .noUi-handle {
    left: auto;
    right: -17px;
}

.noUi-connects {
    border-radius: 10px;
}

.noUi-draggable,
.noUi-vertical .noUi-draggable {
    cursor: col-resize;
}

.noUi-handle {
    background-color: #fff;
    border-radius: 7px;
    box-shadow: 0 0 0 4px #fff3;
    cursor: pointer;
    transition: box-shadow 0.3s;
}

.noUi-vertical .noUi-handle:after,
.noUi-vertical .noUi-handle:before {
    height: 1px;
    left: 6px;
    top: 14px;
    width: 14px;
}

.noUi-vertical .noUi-handle:after {
    top: 17px;
}

[disabled] .noUi-handle,
[disabled].noUi-handle,
[disabled].noUi-target {
    cursor: not-allowed;
}

.noUi-pips,
.noUi-pips * {
    box-sizing: border-box;
}

.noUi-pips {
    color: #999;
    position: absolute;
}

.noUi-value {
    position: absolute;
    text-align: center;
    white-space: nowrap;
}

.noUi-value-sub {
    color: #ccc;
    font-size: 10px;
}

.noUi-marker {
    background: #ccc;
    position: absolute;
}

.noUi-marker-large,
.noUi-marker-sub {
    background: #aaa;
}

.noUi-pips-horizontal {
    height: 80px;
    left: 0;
    padding: 10px 0;
    top: 100%;
    width: 100%;
}

.noUi-value-horizontal {
    transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
    transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
    height: 5px;
    margin-left: -1px;
    width: 2px;
}

.noUi-marker-horizontal.noUi-marker-sub {
    height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
    height: 15px;
}

.noUi-pips-vertical {
    height: 100%;
    left: 100%;
    padding: 0 10px;
    top: 0;
}

.noUi-value-vertical {
    padding-left: 25px;
    transform: translateY(-50%);
}

.noUi-rtl .noUi-value-vertical {
    transform: translateY(50%);
}

.noUi-marker-vertical.noUi-marker {
    height: 2px;
    margin-top: -1px;
    width: 5px;
}

.noUi-marker-vertical.noUi-marker-sub {
    width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
    width: 15px;
}

.blue-board {
    background: #011b3a;
    border-radius: 10px;
    overflow: hidden;
    padding: 12px 16px 14px 15px;
    position: relative;
}

@media (max-width: 550px) {
    .blue-board {
        padding: 12px 12px 15px;
    }
}

@media (max-width: 782px) {
    .opened-left-panel .blue-board {
        padding: 12px 12px 15px;
    }
}

@media (max-width: 875px) {
    .opened-right-panel .blue-board {
        padding: 12px 12px 15px;
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .blue-board {
        padding: 12px 12px 15px;
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .blue-board {
        padding: 12px 12px 15px;
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .blue-board {
        padding: 12px 12px 15px;
    }
}

.blue-board-top {
    display: flex;
    height: 48px;
    justify-content: space-between;
    position: relative;
    z-index: 2;
}

@media (max-width: 550px) {
    .blue-board-top {
        justify-content: center;
        margin-bottom: 25px;
    }
}

@media (max-width: 782px) {
    .opened-left-panel .blue-board-top {
        justify-content: center;
        margin-bottom: 25px;
    }
}

@media (max-width: 875px) {
    .opened-right-panel .blue-board-top {
        justify-content: center;
        margin-bottom: 25px;
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .blue-board-top {
        justify-content: center;
        margin-bottom: 25px;
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .blue-board-top {
        justify-content: center;
        margin-bottom: 25px;
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .blue-board-top {
        justify-content: center;
        margin-bottom: 25px;
    }
}

.blue-board-bot {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 25px auto 0;
    width: -moz-max-content;
    width: max-content;
}

.blue-board-bot-cont {
    display: flex;
}

.blue-board-bot-cont p,
.blue-board-bot-cont span {
    font-size: 12px;
    letter-spacing: -0.02em;
    line-height: 16px;
    margin-bottom: 0;
    margin-right: 3px;
}

@media (max-width: 550px) {

    .blue-board-bot-cont p,
    .blue-board-bot-cont span {
        text-align: center;
    }
}

@media (max-width: 782px) {

    .opened-left-panel .blue-board-bot-cont p,
    .opened-left-panel .blue-board-bot-cont span {
        text-align: center;
    }
}

@media (max-width: 875px) {

    .opened-right-panel .blue-board-bot-cont p,
    .opened-right-panel .blue-board-bot-cont span {
        text-align: center;
    }
}

@media (max-width: 890px) {

    .opened-contests-panel .blue-board-bot-cont p,
    .opened-contests-panel .blue-board-bot-cont span {
        text-align: center;
    }
}

@media (max-width: 1107px) {

    .opened-left-panel.opened-right-panel .blue-board-bot-cont p,
    .opened-left-panel.opened-right-panel .blue-board-bot-cont span {
        text-align: center;
    }
}

@media (max-width: 1122px) {

    .opened-left-panel.opened-contests-panel .blue-board-bot-cont p,
    .opened-left-panel.opened-contests-panel .blue-board-bot-cont span {
        text-align: center;
    }
}

.blue-board-bot-cont p {
    color: #fff;
    font-weight: 600;
}

.blue-board-bot-cont span {
    color: #436690;
}

.blue-board-bot-cont img {
    height: 16px;
    margin-right: 4px;
    width: 16px;
}

@media (max-width: 550px) {
    .blue-board-bot-cont {
        flex-direction: column;
    }
}

@media (max-width: 782px) {
    .opened-left-panel .blue-board-bot-cont {
        flex-direction: column;
    }
}

@media (max-width: 875px) {
    .opened-right-panel .blue-board-bot-cont {
        flex-direction: column;
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .blue-board-bot-cont {
        flex-direction: column;
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .blue-board-bot-cont {
        flex-direction: column;
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .blue-board-bot-cont {
        flex-direction: column;
    }
}

.h-line {
    background: #436690;
    height: 11px;
    margin: 0 11px;
    width: 1px;
}

@media (max-width: 550px) {
    .h-line {
        height: 29px;
    }
}

@media (max-width: 782px) {
    .opened-left-panel .h-line {
        height: 29px;
    }
}

@media (max-width: 875px) {
    .opened-right-panel .h-line {
        height: 29px;
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .h-line {
        height: 29px;
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .h-line {
        height: 29px;
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .h-line {
        height: 29px;
    }
}

.isFullLastBet:after {
    background: linear-gradient(90deg, #01336c, #01336c00);
    bottom: 0;
    content: '';
    display: block;
    left: 0;
    position: absolute;
    top: 0;
    width: 30px;
}

.blue-board .last-bets {
    display: flex;
    flex: 1 1;
    height: 24px;
    justify-content: flex-end;
    margin-bottom: 15px;
    overflow: hidden;
    position: relative;
    width: 100%;
    z-index: 1;
}

.blue-board .last-bets__inner {
    bottom: 0;
    display: flex;
    height: 24px;
    position: absolute;
    right: 0;
    top: 0;
}

.blue-board .last-bets span {
    background: #00091354;
    border-radius: 5px;
    color: #4d75a6;
    font-size: 12px;
    font-weight: 600;
    height: 24px;
    letter-spacing: -0.02em;
    line-height: 24px;
    margin-left: 8px;
    min-width: 50px;
    text-align: center;
}

.blue-board .last-bets span.out {
    background: #24e34d;
    color: #1c2532;
}

.left-roll:after,
.right-roll:after {
    border-right: 1.75px solid #cfcfcf;
    border-top: 1.75px solid #cfcfcf;
    content: '';
    display: block;
    height: 5px;
    left: 50%;
    position: absolute;
    top: 50%;
    width: 5px;
}

.left-roll:after {
    transform: translate(-50%, -50%) rotate(225deg);
}

.right-roll:after {
    transform: translate(-50%, -50%) rotate(45deg);
}

.animWin {
    animation-name: moving-anim;
    animation-duration: var(--duration);
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-direction: alternate;
    transform: translate(-39%) translateY(-48px) scale(1);
}

@keyframes moving-anim {
    50% {
        transform: translate(-39%) translateY(-48px) scale(1.2);
    }

    0% {
        transform: translate(-39%) translateY(-48px) scale(1);
    }
}

.mid-roll {
    z-index: 1;
}

.mid-roll .slider-roll-ins {
    height: 26px;
    width: 26px;
}

.hover-num {
    align-items: center;
    background: #263041;
    border-radius: 8px;
    color: #93acd3;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    height: 36px;
    justify-content: center;
    letter-spacing: -0.02em;
    line-height: 16px;
    transform: translate(-20px, -73px);
    width: 57px;
}

.hover-num:after {
    background: #263041;
    bottom: -10px;
    content: '';
    display: block;
    height: 12px;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%) rotate(45deg);
    width: 12px;
}

.underslide {
    height: calc(var(--the-width) * 0.067);
    background-image: url(../img/underslide.png);
    background-size: 100% 100%;
    bottom: -100%;
    pointer-events: none;
    position: absolute;
    transform: translateY(-13px) scale(1.04);
    width: 100%;
}

@media (max-width: 600px) {
    .underslide {
        height: calc(var(--the-width) * 0.088);
        background-image: url(../img/underslide_mob.png);
        transform: translateY(-10px) scale(1.021);
    }
}

@media (max-width: 832px) {
    .opened-left-panel .underslide {
        height: calc(var(--the-width) * 0.088);
        background-image: url(../img/underslide_mob.png);
        transform: translateY(-10px) scale(1.021);
    }
}

@media (max-width: 925px) {
    .opened-right-panel .underslide {
        height: calc(var(--the-width) * 0.088);
        background-image: url(../img/underslide_mob.png);
        transform: translateY(-10px) scale(1.021);
    }
}

@media (max-width: 940px) {
    .opened-contests-panel .underslide {
        height: calc(var(--the-width) * 0.088);
        background-image: url(../img/underslide_mob.png);
        transform: translateY(-10px) scale(1.021);
    }
}

@media (max-width: 1157px) {
    .opened-left-panel.opened-right-panel .underslide {
        height: calc(var(--the-width) * 0.088);
        background-image: url(../img/underslide_mob.png);
        transform: translateY(-10px) scale(1.021);
    }
}

@media (max-width: 1172px) {
    .opened-left-panel.opened-contests-panel .underslide {
        height: calc(var(--the-width) * 0.088);
        background-image: url(../img/underslide_mob.png);
        transform: translateY(-10px) scale(1.021);
    }
}

@media (max-width: 450px) {
    .underslide {
        transform: translateY(-2px) scale(1.028);
    }
}

@media (max-width: 682px) {
    .opened-left-panel .underslide {
        transform: translateY(-2px) scale(1.028);
    }
}

@media (max-width: 775px) {
    .opened-right-panel .underslide {
        transform: translateY(-2px) scale(1.028);
    }
}

@media (max-width: 790px) {
    .opened-contests-panel .underslide {
        transform: translateY(-2px) scale(1.028);
    }
}

@media (max-width: 1007px) {
    .opened-left-panel.opened-right-panel .underslide {
        transform: translateY(-2px) scale(1.028);
    }
}

@media (max-width: 1022px) {
    .opened-left-panel.opened-contests-panel .underslide {
        transform: translateY(-2px) scale(1.028);
    }
}

.underslide p {
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    bottom: 0;
    font-size: 11px;
    font-weight: 600;
    height: 20px;
    margin: 0;
    padding: 0 3px;
    position: absolute;
    white-space: nowrap;
}

@media (max-width: 450px) {
    .underslide p {
        font-size: 13px;
    }
}

@media (max-width: 682px) {
    .opened-left-panel .underslide p {
        font-size: 13px;
    }
}

@media (max-width: 775px) {
    .opened-right-panel .underslide p {
        font-size: 13px;
    }
}

@media (max-width: 790px) {
    .opened-contests-panel .underslide p {
        font-size: 13px;
    }
}

@media (max-width: 1007px) {
    .opened-left-panel.opened-right-panel .underslide p {
        font-size: 13px;
    }
}

@media (max-width: 1022px) {
    .opened-left-panel.opened-contests-panel .underslide p {
        font-size: 13px;
    }
}

.under_num1 {
    left: 3%;
    top: 105%;
    transform: translate(-50%, -50%) rotate(-7deg);
}

@media (max-width: 450px) {
    .under_num1 {
        top: 99%;
    }
}

@media (max-width: 682px) {
    .opened-left-panel .under_num1 {
        top: 99%;
    }
}

@media (max-width: 775px) {
    .opened-right-panel .under_num1 {
        top: 99%;
    }
}

@media (max-width: 790px) {
    .opened-contests-panel .under_num1 {
        top: 99%;
    }
}

@media (max-width: 1007px) {
    .opened-left-panel.opened-right-panel .under_num1 {
        top: 99%;
    }
}

@media (max-width: 1022px) {
    .opened-left-panel.opened-contests-panel .under_num1 {
        top: 99%;
    }
}

.under_num2 {
    left: 25%;
    top: 73%;
    transform: translate(-50%, -50%) rotate(-3.5deg);
}

.under_num3 {
    left: 50%;
    top: 58%;
    transform: translate(-50%, -50%);
}

@media (max-width: 450px) {
    .under_num3 {
        left: 50%;
        top: 64%;
    }
}

@media (max-width: 682px) {
    .opened-left-panel .under_num3 {
        left: 50%;
        top: 64%;
    }
}

@media (max-width: 775px) {
    .opened-right-panel .under_num3 {
        left: 50%;
        top: 64%;
    }
}

@media (max-width: 790px) {
    .opened-contests-panel .under_num3 {
        left: 50%;
        top: 64%;
    }
}

@media (max-width: 1007px) {
    .opened-left-panel.opened-right-panel .under_num3 {
        left: 50%;
        top: 64%;
    }
}

@media (max-width: 1022px) {
    .opened-left-panel.opened-contests-panel .under_num3 {
        left: 50%;
        top: 64%;
    }
}

.under_num4 {
    left: 75%;
    top: 73%;
    transform: translate(-50%, -50%) rotate(3.5deg);
}

@media (max-width: 450px) {
    .under_num4 {
        left: 75%;
        top: 77%;
    }
}

@media (max-width: 682px) {
    .opened-left-panel .under_num4 {
        left: 75%;
        top: 77%;
    }
}

@media (max-width: 775px) {
    .opened-right-panel .under_num4 {
        left: 75%;
        top: 77%;
    }
}

@media (max-width: 790px) {
    .opened-contests-panel .under_num4 {
        left: 75%;
        top: 77%;
    }
}

@media (max-width: 1007px) {
    .opened-left-panel.opened-right-panel .under_num4 {
        left: 75%;
        top: 77%;
    }
}

@media (max-width: 1022px) {
    .opened-left-panel.opened-contests-panel .under_num4 {
        left: 75%;
        top: 77%;
    }
}

.under_num5 {
    left: 97%;
    top: 105%;
    transform: translate(-50%, -50%) rotate(7deg);
}

@media (max-width: 450px) {
    .under_num5 {
        left: 94%;
        top: 99%;
    }
}

@media (max-width: 682px) {
    .opened-left-panel .under_num5 {
        left: 94%;
        top: 99%;
    }
}

@media (max-width: 775px) {
    .opened-right-panel .under_num5 {
        left: 94%;
        top: 99%;
    }
}

@media (max-width: 790px) {
    .opened-contests-panel .under_num5 {
        left: 94%;
        top: 99%;
    }
}

@media (max-width: 1007px) {
    .opened-left-panel.opened-right-panel .under_num5 {
        left: 94%;
        top: 99%;
    }
}

@media (max-width: 1022px) {
    .opened-left-panel.opened-contests-panel .under_num5 {
        left: 94%;
        top: 99%;
    }
}



.space-max-payout {
    align-items: center;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    background: #0e2645cc;
    border: 1px solid #1a314d;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    height: 43px;
    justify-content: center;
    left: 50%;
    position: absolute;
    top: -63px;
    transform: translate(-50%);
    width: 124px;
    z-index: 1;
}

.space-max-payout-s {
    color: #93acd3;
    font-size: 11px;
}

.space-max-payout p,
.space-max-payout-s {
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 16px;
}

.space-max-payout p {
    align-items: center;
    color: #fff;
    display: flex;
    font-size: 12px;
    margin: 2px 0 0;
}

.midle-sld {
    background: transparent;
    height: 26px;
    width: 26px;
}

.midle-sld svg {
    transform: scale(1.1) translate(-1px, -2px);
}
</style>
